// Light haptic feedback for mobile taps (no-op where unsupported)
export function haptic(pattern = 10) {
  try {
    if (typeof navigator !== "undefined" && navigator.vibrate) {
      navigator.vibrate(pattern);
    }
  } catch {
    /* noop */
  }
}
